<script lang='ts'>
  export let title: string
  export let desc: string
</script>

<div class='py-6'>
  <h1 class='w-full font-bold text-white text-4xl mb-4 mt-2'>{title}</h1>
  <p class='text-muted-foreground text-base w-[600px] mw-full leading-normal'>{desc}</p>
</div>
